import uniqBy from 'lodash/uniqBy';
import { Surface } from '../../../../store/types/prescription';
import { ChartType } from './DentalChart';

export type Teeth = {
    id: string;
    name: string;
    common_name: string;
    tooth: string;
    surfaces: {
        name: string;
        id: string;
        index: number;
    }[];
};

const adultUpperTeeth = [
    {
        id: 'sm-2101439609',
        name: 'Entire maxillary right third molar tooth',
        common_name: 'Molar 3',
        tooth: '18',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2101469404',
        name: 'Entire maxillary right second molar tooth',
        common_name: 'Molar 2',
        tooth: '17',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2101499190',
        name: 'Entire maxillary right first molar tooth',
        common_name: 'Molar 1',
        tooth: '16',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102184387',
        name: 'Entire maxillary right second premolar tooth',
        common_name: 'Premolar 2',
        tooth: '15',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102214177',
        name: 'Entire maxillary right first premolar tooth',
        common_name: 'Premolar 1',
        tooth: '14',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102243966',
        name: 'Entire permanent maxillary right canine tooth',
        common_name: 'Canine',
        tooth: '13',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102303547',
        name: 'Entire maxillary right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '12',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102333337',
        name: 'Entire maxillary right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '11',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103316447',
        name: 'Entire maxillary left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '21',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103286652',
        name: 'Entire maxillary left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '22',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103227067',
        name: 'Entire permanent maxillary left canine tooth',
        common_name: 'Canine',
        tooth: '23',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103197282',
        name: 'Entire maxillary left first premolar tooth',
        common_name: 'Premolar 1',
        tooth: '24',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103167486',
        name: 'Entire maxillary left second premolar tooth',
        common_name: 'Premolar 2',
        tooth: '25',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102452507',
        name: 'Entire maxillary left first molar tooth',
        common_name: 'Molar 1',
        tooth: '26',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102422713',
        name: 'Entire maxillary left second molar tooth',
        common_name: 'Molar 2',
        tooth: '27',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102392927',
        name: 'Entire maxillary left third molar tooth',
        common_name: 'Molar 3',
        tooth: '28',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

const pediaUpperTeeth = [
    {
        id: 'sm-2125421363',
        name: 'Entire deciduous maxillary right second molar tooth',
        common_name: 'Molar 2',
        tooth: '55',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125451153',
        name: 'Entire deciduous maxillary right first molar tooth',
        common_name: 'Molar 1',
        tooth: '54',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125480948',
        name: 'Entire deciduous maxillary right canine tooth',
        common_name: 'Canine',
        tooth: '53',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125540533',
        name: 'Entire deciduous maxillary right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '52',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126195929',
        name: 'Entire deciduous maxillary right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '51',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126404468',
        name: 'Entire deciduous maxillary left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '61',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126374681',
        name: 'Entire deciduous maxillary left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '62',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126315097',
        name: 'Entire deciduous maxillary left canine tooth',
        common_name: 'Canine',
        tooth: '63',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126285300',
        name: 'Entire deciduous maxillary left first molar tooth',
        common_name: 'Molar 1',
        tooth: '64',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126255514',
        name: 'Entire deciduous maxillary left second molar tooth',
        common_name: 'Molar 2',
        tooth: '65',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

const mixedUpperTeeth = [
    {
        id: 'sm-2101499190',
        name: 'Entire maxillary right first molar tooth',
        common_name: 'Molar 1',
        tooth: '16',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125421363',
        name: 'Entire deciduous maxillary right second molar tooth',
        common_name: 'Molar 2',
        tooth: '55',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125451153',
        name: 'Entire deciduous maxillary right first molar tooth',
        common_name: 'Molar 1',
        tooth: '54',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125480948',
        name: 'Entire deciduous maxillary right canine tooth',
        common_name: 'Canine',
        tooth: '53',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102303547',
        name: 'Entire maxillary right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '12',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102333337',
        name: 'Entire maxillary right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '11',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103316447',
        name: 'Entire maxillary left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '21',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2103286652',
        name: 'Entire maxillary left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '22',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126315097',
        name: 'Entire deciduous maxillary left canine tooth',
        common_name: 'Canine',
        tooth: '63',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126285300',
        name: 'Entire deciduous maxillary left first molar tooth',
        common_name: 'Molar 1',
        tooth: '64',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2126255514',
        name: 'Entire deciduous maxillary left second molar tooth',
        common_name: 'Molar 2',
        tooth: '65',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Palatal',
                id: 'sm-2154020726',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2102452507',
        name: 'Entire maxillary left first molar tooth',
        common_name: 'Molar 1',
        tooth: '26',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

export const upperTeeth = (chartType?: ChartType): Teeth[] => {
    if (chartType === 'adult') return adultUpperTeeth;
    if (chartType === 'pedia') return pediaUpperTeeth;
    if (chartType === 'mixed') return mixedUpperTeeth;
    return [];
};

const adultLowerTeeth = [
    {
        id: 'sm-2104031425',
        name: 'Entire permanent mandibular right third molar tooth',
        common_name: 'Molar 3',
        tooth: '48',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104061217',
        name: 'Entire mandibular right second molar tooth',
        common_name: 'Molar 2',
        tooth: '47',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104091010',
        name: 'Entire mandibular right first molar tooth',
        common_name: 'Molar 1',
        tooth: '46',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104180385',
        name: 'Entire mandibular right second premolar tooth',
        common_name: 'Premolar 2',
        tooth: '45',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104210177',
        name: 'Entire permanent mandibular right first premolar tooth',
        common_name: 'Premolar 1',
        tooth: '44',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104239964',
        name: 'Entire permanent mandibular right canine tooth',
        common_name: 'Canine',
        tooth: '43',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104299543',
        name: 'Entire mandibular right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '42',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124348888',
        name: 'Entire mandibular right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '41',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125302203',
        name: 'Entire mandibular left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '31',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125272413',
        name: 'Entire permanent mandibular left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '32',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124587218',
        name: 'Entire permanent mandibular left canine tooth',
        common_name: 'Canine',
        tooth: '33',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124557422',
        name: 'Entire mandibular left first premolar tooth',
        common_name: 'Premolar 1',
        tooth: '34',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124527640',
        name: 'Entire mandibular left second premolar tooth',
        common_name: 'Premolar 2',
        tooth: '35',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124468056',
        name: 'Entire mandibular left first molar tooth',
        common_name: 'Molar 1',
        tooth: '36',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124438259',
        name: 'Entire mandibular left second molar tooth',
        common_name: 'Molar 2',
        tooth: '37',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124408473',
        name: 'Entire mandibular left third molar tooth',
        common_name: 'Molar 3',
        tooth: '38',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

const pediaLowerTeeth = [
    {
        id: 'sm-2127119454',
        name: 'Entire deciduous mandibular right second molar tooth',
        common_name: 'Molar 2',
        tooth: '85',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127149244',
        name: 'Entire deciduous mandibular right first molar tooth',
        common_name: 'Molar 1',
        tooth: '84',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127179033',
        name: 'Entire deciduous mandibular right canine tooth',
        common_name: 'Canine',
        tooth: '83',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127238614',
        name: 'Entire deciduous mandibular right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '82',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127268404',
        name: 'Entire deciduous mandibular right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '81',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2128102552',
        name: 'Entire deciduous mandibular left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '71',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2128072768',
        name: 'Entire deciduous mandibular left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '72',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127387574',
        name: 'Entire deciduous mandibular left canine tooth',
        common_name: 'Canine',
        tooth: '73',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127357780',
        name: 'Entire deciduous mandibular left first molar tooth',
        common_name: 'Molar 1',
        tooth: '74',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127327994',
        name: 'Entire deciduous mandibular left second molar tooth',
        common_name: 'Molar 2',
        tooth: '75',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

const mixedLowerTeeth = [
    {
        id: 'sm-2104091010',
        name: 'Entire mandibular right first molar tooth',
        common_name: 'Molar 1',
        tooth: '46',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127119454',
        name: 'Entire deciduous mandibular right second molar tooth',
        common_name: 'Molar 2',
        tooth: '85',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127149244',
        name: 'Entire deciduous mandibular right first molar tooth',
        common_name: 'Molar 1',
        tooth: '84',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127179033',
        name: 'Entire deciduous mandibular right canine tooth',
        common_name: 'Canine',
        tooth: '83',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2104299543',
        name: 'Entire mandibular right lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '42',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124348888',
        name: 'Entire mandibular right central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '41',
        surfaces: [
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125302203',
        name: 'Entire mandibular left central incisor tooth',
        common_name: 'Cental Incisors',
        tooth: '31',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2125272413',
        name: 'Entire permanent mandibular left lateral incisor tooth',
        common_name: 'Lateral Incisors',
        tooth: '32',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127387574',
        name: 'Entire deciduous mandibular left canine tooth',
        common_name: 'Canine',
        tooth: '73',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Incisal',
                id: 'sm-9440921098',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127357780',
        name: 'Entire deciduous mandibular left first molar tooth',
        common_name: 'Molar 1',
        tooth: '74',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2127327994',
        name: 'Entire deciduous mandibular left second molar tooth',
        common_name: 'Molar 2',
        tooth: '75',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Buccal',
                id: 'sm-2128251513',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
    {
        id: 'sm-2124468056',
        name: 'Entire mandibular left first molar tooth',
        common_name: 'Molar 1',
        tooth: '36',
        surfaces: [
            {
                name: 'Distal',
                id: 'sm-9628008876',
                index: 1,
            },
            {
                name: 'Lingual',
                id: 'sm-7235077011',
                index: 2,
            },
            {
                name: 'Mesial',
                id: 'sm-9440980678',
                index: 3,
            },
            {
                name: 'Labial',
                id: 'sm-7761999235',
                index: 4,
            },
            {
                name: 'Occlusal',
                id: 'sm-9440950884',
                index: 5,
            },
            {
                name: 'Cervical',
                id: 'sm-5519827198',
                index: 6,
            },
            {
                name: 'Root',
                id: 'sm-8792927854',
                index: 7,
            },
        ],
    },
];

export const lowerTeeth = (chartType?: ChartType): Teeth[] => {
    if (chartType === 'adult') return adultLowerTeeth;
    if (chartType === 'pedia') return pediaLowerTeeth;
    if (chartType === 'mixed') return mixedLowerTeeth;
    return [];
};

const allTeeth = (chartType: ChartType) => [...upperTeeth(chartType), ...lowerTeeth(chartType)];

interface ToothData {
    id: string;
    name: string;
}

export type TeethData = ToothData[];

export const allTeethData = (chartType: ChartType): TeethData =>
    allTeeth(chartType).map((i) => ({ id: i.tooth, name: i.tooth }));

interface SurfacesToName {
    [k: number]: string;
}

export interface TeethToSurfacesNames {
    [k: string]: SurfacesToName;
}

interface TeethToSurfacesArray {
    [k: string]: Surface[];
}

export const teethToSurfacesNames = (chartType: ChartType): TeethToSurfacesNames => {
    const teethToSurfacesNamesObject: TeethToSurfacesNames = {};
    allTeeth(chartType).forEach((tooth) => {
        const nameObj: SurfacesToName = {};
        tooth.surfaces.forEach((surface) => (nameObj[surface.index] = surface.name));
        teethToSurfacesNamesObject[tooth.tooth] = nameObj;
    });
    return teethToSurfacesNamesObject;
};

export const teethToSurfacesIds = (chartType: ChartType): TeethToSurfacesNames => {
    const teethToSurfacesIdsObject: TeethToSurfacesNames = {};
    allTeeth(chartType).forEach((tooth) => {
        const idObj: SurfacesToName = {};
        tooth.surfaces.forEach((surface) => (idObj[surface.index] = surface.id));
        teethToSurfacesIdsObject[tooth.tooth] = idObj;
    });
    return teethToSurfacesIdsObject;
};

const defaultSurfaces = [
    {
        id: 'sm-2100426715',
        name: 'UR Quadrant ┘',
    },
    {
        id: 'sm-2100396929',
        name: 'UL Quadrant └',
    },
    {
        id: 'sm-2100486299',
        name: 'LL Quadrant ┌',
    },
    {
        id: 'sm-2100456512',
        name: 'LR Quadrant ┐',
    },
];

export const teethToSurfacesArray = (chartType: ChartType): TeethToSurfacesArray => {
    const teethToSurfacesArrayObject: TeethToSurfacesArray = {};
    allTeeth(chartType).forEach((tooth) => {
        teethToSurfacesArrayObject[tooth.tooth] = [...tooth.surfaces, ...defaultSurfaces];
    });
    return teethToSurfacesArrayObject;
};

export const allSurfaces = [
    {
        id: 'sm-9440980678',
        name: 'Mesial',
    },
    {
        id: 'sm-9628008876',
        name: 'Distal',
    },
    {
        id: 'sm-7761999235',
        name: 'Labial',
    },
    {
        id: 'sm-7235077011',
        name: 'Lingual',
    },
    {
        id: 'sm-9440921098',
        name: 'Incisal',
    },
    {
        id: 'sm-9440950884',
        name: 'Occlusal',
    },
    {
        id: 'sm-2128251513',
        name: 'Buccal',
    },
    {
        id: 'sm-2154020726',
        name: 'Palatal',
    },
    {
        id: 'sm-5519827198',
        name: 'Cervical',
    },
    {
        id: 'sm-8792927854',
        name: 'Root',
    },
    ...defaultSurfaces,
];

const allSurfacesIdToNameObject: { [k: string]: string } = {};

allSurfaces.forEach((i) => {
    allSurfacesIdToNameObject[i.id] = i.name;
});

export const allSurfacesIdToName = allSurfacesIdToNameObject;

export const ALL_TEETH_ID = 'sm-1723615519';
export const ORAL_FINDINGS = 'ORAL FINDINGS';

export const TEETH_TO_NAME: { [k: string]: string } = {
    [ALL_TEETH_ID]: ORAL_FINDINGS,
};

export const allTypeUpperTeeth = [...adultUpperTeeth, ...pediaUpperTeeth, ...mixedUpperTeeth];
export const allTypeLowerTeeth = [...adultLowerTeeth, ...pediaLowerTeeth, ...mixedLowerTeeth];

const allTypeTeeth = [...allTypeUpperTeeth, ...allTypeLowerTeeth].map((i) => ({
    id: i.tooth,
    name: i.tooth,
}));

export const allTypeUniqueTeeth = uniqBy(allTypeTeeth, 'id');
